import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  svg {\n    transition: transform 0.3s;\n  }\n  :hover {\n    svg {\n      transform: scale(1.2);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Text from "../Text/Text";
import Skeleton from "../Skeleton/Skeleton";
import DefiIcon from "../Svg/Icons/DefiIcon";
import { useEffect, useState } from "react";
import axios from "axios";
var PriceLink = styled.a.withConfig({
    componentId: "sc-53e3a93c-0"
})(_templateObject());
var CakePrice = function(param) {
    var cakePriceUsd = param.cakePriceUsd, _color = param.color, color = _color === void 0 ? "textSubtle" : _color, _showSkeleton = param.showSkeleton, showSkeleton = _showSkeleton === void 0 ? true : _showSkeleton;
    var ref = useState(0), cakePrice = ref[0], setCakePrice = ref[1];
    useEffect(function() {
        // setInterval(() => {
        fetchDefcPrice();
    // }, 30000)
    }, []);
    var fetchDefcPrice = function() {
        axios.get("https://api.coingecko.com/api/v3/coins/defi-coin").then(function(res) {
            setCakePrice(res.data.market_data.current_price.usd);
        });
    };
    return cakePriceUsd ? /*#__PURE__*/ _jsxs(PriceLink, {
        //  href="https://defiswap-demo-atulinfranix-gmailcom.vercel.app/swap"
        target: "_blank",
        children: [
            /*#__PURE__*/ _jsx(DefiIcon, {
                width: "10px",
                mr: "12px"
            }),
            "\xa0\xa0",
            /*#__PURE__*/ _jsx(Text, {
                color: color,
                bold: true,
                children: cakePrice
            })
        ]
    }) : showSkeleton ? /*#__PURE__*/ _jsx(Skeleton, {
        width: 80,
        height: 24
    }) : null;
};
export default /*#__PURE__*/ React.memo(CakePrice);
